import callApi from '../../util/apiCaller';

import { localizationData, defaultLanguage, enabledLanguages, fallbackLanguage } from '../../../Intl/setup';
import { getUserPreference, setUserPreferenceRequest } from '../User/UserActions';
import { setDateLanguage } from '../../util/date';

// Export Constants
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';

export function initLanguage(lang = null, user = null, store = null) {
    return dispatch => {
        if(!lang) {
            if(store && store.intl && store.intl.isInit) {
                lang = store.intl.locale;
            } else if(global.navigator && global.navigator.language) {
                const navigatorLanguage = global.navigator.language.split('-')[0];
                lang = navigatorLanguage;
            }
            // const initLocale = global.navigator && global.navigator.language || 'en';
        }
        if(enabledLanguages.indexOf(lang) === -1) {
            // console.log('lang not enabled!', lang);
            lang = fallbackLanguage;
        }
        return callApi(`intl/language/${lang}`).then(res => {
            // console.log('intl/language/', lang, res);
            if(res) {
                dispatch(switchLanguage(lang, res));
                // localizationData n'est plus hydraté côté client (catalogues via API) :
                // on persiste dès qu'une langue activée diffère de la préférence compte.
                if(user && lang && lang !== getUserPreference(user, 'language')) {
                    dispatch(setUserPreferenceRequest('language', lang));
                }
                // console.log('Lang set', lang);
                return lang;
            }
            return null;
        }).catch(err => {
            return null;
        });
    };
}

export function getEnabledLanguages() {
    return enabledLanguages;
}

export function getDefaultLanguages() {
    return defaultLanguage;
}

export function getCountryFromLanguage(lang) {
    switch(lang) {
        case 'en':
            return 'GB';

        case 'ja':
            return 'JP';

        case 'ko':
            return 'KR';

        default:
            return lang && lang.toUpperCase();
    }
}

export function switchLanguage(newLang, data = {}) {
    console.log('switchLanguage', data);
    if(newLang && (data || localizationData[newLang])) {
        setDateLanguage(newLang);
        const messages = (data || localizationData[newLang] || {}).messages || {};

        return {
            type: SWITCH_LANGUAGE,
            locale: newLang,
            messages,
            isInit: true,
        };
    }
    return {
        type: SWITCH_LANGUAGE,
    };
}
